<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-6 left">
        Left
      </div>

      <div class="col-lg-6 right">
        <div class="info">
          RIGHT
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import * as d3 from "d3";
  import * as topojson from "topojson";
  import Vue from "vue";

  export default {
    name: "ViewMaps",
    components: {},
    data() {
      return {
        
      };
    },
    methods: {
      
    },
  };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .container-fluid{
        color: #FFF;
        .row{
            .left{

            }
            .right{
                margin-left: 50%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/TestComponent.vue